import Vue from "vue";
import Api from "../../services/Api";
const alerts = {
    namespaced: true,
    state: {
        items: [],
        error: null,
        interval: undefined
    },
    getters: {
        get: state => {
            return state.items;
        }
    },
    mutations: {
        set: (state, payload) => {
            state.items = payload.items;
        }
    },
    actions: {
        refresh: (context, payload) => {
            Api()
                .get("/api/" + payload.company + "/alert")
                .then(response => {
                    context.commit("set", { items: response.data });
                    // if(context.state.interval == undefined){
                    context.state.interval = setTimeout(() => {
                        context.dispatch("refresh", payload);
                    }, 30000);
                    // }
                })
                .catch(error => {
                    context.state.error = error;
                    // if(context.state.interval == undefined){
                    context.state.interval = setTimeout(() => {
                        context.dispatch("refresh", payload);
                    }, 30000);
                    // }
                });
        },
        dismissAlert: (context, payload) => {
            return Api()
                .post("/api/" + payload.company + "/dismissAlert", {
                    id: payload.id
                })
                .then(response => {
                    context.dispatch("refresh", { company: payload.company });
                    return response;
                })
                .catch(error => {
                    context.state.error = error;
                    throw error;
                });
        }
    }
};

export default alerts;


// WEBPACK FOOTER //
// ./resources/js/store/modules/alerts.js